/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncDownloadScanRequest
 */
export interface SyncDownloadScanRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncDownloadScanRequest
     */
    downloadUrl: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SyncDownloadScanRequest
     */
    downloadHeaders?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SyncDownloadScanRequest interface.
 */
export function instanceOfSyncDownloadScanRequest(value: object): value is SyncDownloadScanRequest {
    if ((!('downloadUrl' in value) && !('download_url' in value)) || (value['downloadUrl'] === undefined && value['download_url'] === undefined)) return false;
    return true;
}

export function SyncDownloadScanRequestFromJSON(json: any): SyncDownloadScanRequest {
    return SyncDownloadScanRequestFromJSONTyped(json, false);
}

export function SyncDownloadScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncDownloadScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadUrl': json['download_url'],
        'downloadHeaders': json['download_headers'] == null ? undefined : json['download_headers'],
    };
}

export function SyncDownloadScanRequestToJSON(json: any): SyncDownloadScanRequest {
    return SyncDownloadScanRequestToJSONTyped(json, false);
}

export function SyncDownloadScanRequestToJSONTyped(value?: SyncDownloadScanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'download_url': value['downloadUrl'],
        'download_headers': value['downloadHeaders'],
    };
}

